import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import * as React from 'react';
import { TxpGriffinSettingsPayload } from 'owa-calendar-configuration';
import TxpSettingsEntryPoint from 'owa-calendar-configuration/lib/store/schema/TxpSettingsEntryPoint';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import {
    ErrorMessageSettingsSaveFailedTitle,
    ErrorMessageSettingsSaveFailedText,
    settingsCancelButtonText,
    settingsSaveButtonText,
} from '../strings.locstring.json';
import loc from 'owa-localize';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import getStore from '../store/store';
import TxpSettingsDialogViewStates from '../store/viewSchema/TxpSettingsDialogViewStates';
import { setTxpSettingsErrorDialogViewState } from '../actions/txpSettingsDialogActions';
import sendChangedTxpSettings from '../utils/actions/sendChangedTxpSettings';
import cleanupTxpSettingsDialog from '../utils/view/cleanupTxpSettingsDialog';
import { observer } from 'mobx-react';
import { createCalendarPerfDatapoint } from 'owa-shared-analytics';
import { TxpSettingsDataPointNames } from 'owa-calendar-configuration/lib/helpers/TxpConstants';

let styles = require('./TxpSettingsDialog.scss');

export interface TxpSettingsErrorDialogProps {
    entryPoint: TxpSettingsEntryPoint;
    changedSettings: TxpGriffinSettingsPayload;
}

@observer
export default class TxpSettingsErrorDialog extends React.Component<TxpSettingsErrorDialogProps> {
    render() {
        const store = getStore();
        const viewState = store.txpSettingsErrorDialogViewState;
        const isSaving = viewState === TxpSettingsDialogViewStates.Saving;

        return (
            <Dialog
                hidden={viewState === TxpSettingsDialogViewStates.Hidden}
                type={DialogType.normal}
                onDismiss={this.onDiscard}
                title={loc(ErrorMessageSettingsSaveFailedTitle)}
                subText={loc(ErrorMessageSettingsSaveFailedText)}
                modalProps={{
                    isDarkOverlay: true,
                    className: styles.dialogBox,
                }}>
                <DialogFooter>
                    <div className={styles.dialogFooterButtons}>
                        {isSaving ? (
                            <Spinner size={SpinnerSize.large} className={styles.spinner} />
                        ) : (
                            <div className={styles.spinnerPlaceholder} />
                        )}
                        <PrimaryButton
                            onClick={this.onSave}
                            text={loc(settingsSaveButtonText)}
                            disabled={isSaving}
                        />
                        <DefaultButton
                            onClick={this.onDiscard}
                            text={loc(settingsCancelButtonText)}
                            disabled={isSaving}
                        />
                    </div>
                </DialogFooter>
            </Dialog>
        );
    }

    onDiscard() {
        setTxpSettingsErrorDialogViewState(TxpSettingsDialogViewStates.Hidden);
        cleanupTxpSettingsDialog();
    }

    onSave = async () => {
        setTxpSettingsErrorDialogViewState(TxpSettingsDialogViewStates.Saving);

        const txpSettingsSaveDatapoint = createCalendarPerfDatapoint(
            TxpSettingsDataPointNames.TxpSettingsSaveV2
        );
        sendChangedTxpSettings(this.props.changedSettings, txpSettingsSaveDatapoint).then(
            isSaveSuccessful => {
                if (isSaveSuccessful) {
                    setTxpSettingsErrorDialogViewState(TxpSettingsDialogViewStates.Hidden);
                    cleanupTxpSettingsDialog();
                } else {
                    setTxpSettingsErrorDialogViewState(TxpSettingsDialogViewStates.Shown);
                }
            }
        );
    };
}
